import { render } from "./Partners.vue?vue&type=template&id=12f94e38&scoped=true"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"

import "./Partners.vue?vue&type=style&index=0&id=12f94e38&lang=scss"
import "./Partners.vue?vue&type=style&index=1&id=12f94e38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f94e38"]])

export default __exports__